import {
  Autocomplete,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import {
  Admin_Parivartan_Create_New_City,
  Admin_Parivartan_Create_New_Pincode,
  Admin_Parivartan_Get_All_Cities,
  Admin_Parivartan_Get_All_States,
} from "../../../../constants";
import axios from "axios";
import toast from "react-hot-toast";

const AddPincodeModal = ({ open, onClose, onRefresh }) => {
  const [form, setForm] = useState({
    PlaceName: "",
    CityName: "",
    Pincode: "",
  });
  const [cityList, setCityList] = useState([]);

  const fetchCityData = async () => {
    try {
      const response = await axios.get(`${Admin_Parivartan_Get_All_Cities}`);
      setCityList(response.data.data || []);
    } catch (error) {
      console.error("Error fetching attendance data:", error);
    }
  };

  useEffect(() => {
    fetchCityData();
  }, [open]);

  const handleChange = (field, value) => {
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  const handleSubmit = async () => {
    const payload = {
      PlaceName: form.PlaceName,
      CityName: form.CityName,
      Pincode: form.Pincode,
    };

    try {
      const res = await axios.post(
        Admin_Parivartan_Create_New_Pincode,
        payload
      );
      if (res.data.success) {
        toast.success("Pincode Created Successfully.");
        onRefresh();
        onClose();
        handleReset();
      } else {
        toast.error(res.data.message || "Failed to create pincode.");
      }
    } catch (err) {
      const message =
        err?.response?.data?.message || err?.message || "Something went wrong";
      toast.error(message);
    }
  };

  const handleReset = () => {
    setForm({
      PlaceName: "",
      CityName: "",
      Pincode: "",
    });
  };

  return (
    <>
      <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
        <DialogTitle>
          <Typography variant="h6" fontWeight="bold">
            Add New Pincode
          </Typography>
        </DialogTitle>
        <DialogContent>
          <Stack spacing={2} mt={1}>
            <FormControl fullWidth>
              <TextField
                label="Place Name"
                value={form.PlaceName}
                onChange={(e) => handleChange("PlaceName", e.target.value)}
                variant="outlined"
                size="small"
              />
            </FormControl>

            <Autocomplete
              size="small"
              options={cityList} // list of cities
              getOptionLabel={(option) => option.CityName ?? ""} // must return string
              value={cityList.find((c) => c.CityId === form.CityName) || null}
              onChange={(event, newValue) => {
                handleChange("CityName", newValue ? newValue.CityId : "");
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="City Name"
                  placeholder="Select City"
                />
              )}
              isOptionEqualToValue={(option, value) =>
                option.CityId === value.CityId
              }
            />
          </Stack>

          <FormControl fullWidth sx={{ mt: 2 }}>
            <TextField
              label="Pincode"
              value={form.Pincode}
              onChange={(e) => {
                const value = e.target.value;
                // allow only digits and max 6
                if (/^\d{0,6}$/.test(value)) {
                  handleChange("Pincode", value);
                }
              }}
              variant="outlined"
              size="small"
              inputProps={{
                maxLength: 6,
                pattern: "[0-9]{6}", // for extra browser-level validation
              }}
              error={form.Pincode.length > 0 && form.Pincode.length !== 6}
              helperText={
                form.Pincode.length > 0 && form.Pincode.length !== 6
                  ? "Pincode must be 6 digits"
                  : ""
              }
            />
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button
            variant="outlined"
            onClick={() => {
              onClose();
            }}
          >
            Cancel
          </Button>
          <Button variant="contained" onClick={handleSubmit}>
            Add
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default AddPincodeModal;
